<template>
  <div class="mb-8">
    <section class="course w-full rounded-lg overflow-hidden items-center">
      <div
        class="course__banner vx-row flex justify-between flex-wrap px-5 pt-5"
      >
        <div class="course__banner__info vx-col text-left md:w-3/4 md:pr-20">
          <h3
            class="course__banner__info--heading text-black text-xl font-semibold pb-3"
          >
            {{ course.title }}
          </h3>
          <p class="course__banner__info--text text-justify">
            {{ course.description }}
          </p>
          <div class="flex items-center flex-wrap mt-3 mb-4 md:mb-0">
            <div
              class="course__banner__info__company flex items-center mr-2 md:mr-5 mt-3"
            >
              <img
                class="course__banner__info__company--logo"
                :src="require(`@/assets/images/user-dashboard/gbLogo.svg`)"
                alt="Compnay logo"
              />
              <p
                class="course__banner__info__company--name ml-2 text-sm font-semibold"
              >
                GetBoarded
              </p>
            </div>
            <div
              class="course__banner__info__calender flex items-center mr-2 md:mr-5 mt-3"
            >
              <img
                class="course__banner__info__calender--icon"
                :src="
                  require(`@/assets/images/user-dashboard/calendarIcon.svg`)
                "
                alt="Calendar Icon"
              />
              <p class="course__banner__info__calender--date ml-2 text-sm">
                13-14 Oct 2023
              </p>
            </div>
            <div
              class="course__banner__info__location flex items-center mr-2 md:mr-5 mt-3"
            >
              <img
                class="course__banner__info__location--icon"
                :src="require(`@/assets/images/user-dashboard/mapIcon.svg`)"
                alt="Location Icon"
              />
              <p class="course__banner__info__location--place ml-2 text-sm">
                Aveiro, Portugal
              </p>
            </div>
          </div>
        </div>
        <div class="vx-col w-full md:w-1/4">
          <img
            class="course__banner__img w-full h-full object-cover"
            :src="require(`@/assets/images/user-dashboard/altfBanner.svg`)"
            alt="ALT+F Banner"
          />
        </div>
      </div>
      <vs-divider />
      <div class="course__tag flex items-center justify-between p-5">
        <div class="flex items-center flex-wrap">
          <span
            class="course__tag__tags text-sm text-black font-medium mr-2 mb-2"
            >#digitalassets</span
          >
          <span
            class="course__tag__tags text-sm text-black font-medium mr-2 mb-2"
            >#futureofNFTs</span
          >
          <span
            class="course__tag__tags text-sm text-black font-medium mr-2 mb-2"
            >#cryptoart</span
          >
        </div>
        <button
          class="course__tag__collapse border-none cursor-pointer"
          @click="collapseTicket()"
        >
          <img
            class="transform transition-transform duration-500"
            :class="showTickets ? 'rotate-180' : ''"
            :src="require(`@/assets/images/user-dashboard/arrowDown.svg`)"
            alt="collapse btn"
          />
        </button>
      </div>
      <div :class="showTickets ? 'show' : 'hide'">
        <div
          class="course__ticket flex justify-between flex-wrap px-8 py-5"
          v-for="(subTask, index) in course.subLibraryItems"
          :key="index"
        >
          <div class="flex items-center w-7/12">
            <div class="course__ticket__date rounded-lg px-4 pt-2">
              <p class="text-white text-sm font-medium leading-none">
                {{ getTaskMonth(subTask.startDate) }}
              </p>
              <p class="text-white text-3xl font-extrabold">
                {{ getTaskDate(subTask.startDate) }}
              </p>
            </div>
            <div class="course__ticket__info text-left ml-5">
              <h3 class="text-black font-semibold text-lg pb-2">
                {{ subTask.title }}
              </h3>
              <p class="text-sm">
                TIME -
                {{
                  getTaskDuration(
                    subTask.startDate,
                    subTask.endDate ? subTask.endDate : ""
                  )
                }}
              </p>
            </div>
          </div>
          <div
            class="course__ticket__status flex items-center justify-end w-1/2 md:w-4/12"
          >
            <vs-chip class="my-4" color="#FEC">
              <vs-chip
                class="text-black cursor-pointer font-bold px-3 py-1"
                @click.native="setStatus('do')"
                :color="status === 'do' ? '#f2c244' : '#FEC'"
              >
                Do
              </vs-chip>
              <vs-chip
                class="text-black cursor-pointer font-bold px-3 py-1"
                @click.native="setStatus('doing')"
                :color="status === 'doing' ? '#f2c244' : '#FEC'"
              >
                Doing
              </vs-chip>
              <vs-chip
                class="text-black cursor-pointer font-bold px-3 py-1"
                @click.native="setStatus('done')"
                :color="status === 'done' ? '#f2c244' : '#FEC'"
              >
                Done
              </vs-chip>
            </vs-chip>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import constants from "@/constants";
export default {
  data() {
    return {
      showTickets: true,
      constants,
      status: "do",
      status1: "do",
      status2: "do",
    };
  },
  props: {
    course: {
      required: true,
    },
  },
  methods: {
    collapseTicket() {
      this.showTickets = !this.showTickets;
    },
    setStatus(val) {
      this.status = val;
    },
    setStatus1(val) {
      this.status1 = val;
    },
    setStatus2(val) {
      this.status2 = val;
    },
    getTaskMonth(date) {
      const dateObject = new Date(date);
      const monthNumber = dateObject.getMonth() + 1;
      const monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      return monthNumber
        ? monthNames[monthNumber].substring(0, 3).toUpperCase()
        : "";
    },
    getTaskDate(date) {
      const dateObject = new Date(date);
      return dateObject.getDate();
    },
    getTaskDuration(startTaskDate, endTaskDate) {
      const startDate = new Date(startTaskDate);
      const endDate = endTaskDate ? new Date(endTaskDate) : "";
      if (endDate && startDate.toDateString() === endDate.toDateString()) {
        const startTime = startDate.toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        });
        const endTime = endDate.toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        });
        const timeRange = `${startTime} - ${endTime}`;
        return timeRange;
      } else {
        // console.log("Dates are not the same.");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
$primary-color: #667085;
$secondary-color: #344054;
$primary-background: #fff;
$secondary-background: #f2f4f7;
$gradient-background: linear-gradient(98deg, #439dfe 0%, #f687ff 100%);
.course {
  background: $primary-background;
  box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.1);
  &__banner {
    &__info {
      &--text {
        color: $primary-color !important;
      }
      &__company {
        &--name {
          color: $secondary-color !important;
        }
      }
      &__calender {
        &--date {
          color: $secondary-color !important;
        }
      }
      &__location {
        &--place {
          color: $secondary-color !important;
        }
      }
    }
    &__img {
      border-radius: 0.325rem;
      max-width: 15em;
      max-height: 12em;
    }
  }
  &__tag {
    &__tags {
      background: $secondary-background;
      border-radius: 6.25rem;
      padding: 0.2rem 0.8rem;
    }
    &__collapse {
      background: $secondary-background;
      border-radius: 6.25rem;
      padding: 0.25rem 0.35rem;
    }
  }
  .show {
    animation: fadeIn 0.5s ease-in-out forwards;
  }
  .hide {
    animation: fadeOut 0.3s ease-in-out forwards;
  }
  &__ticket {
    border-top: dashed;
    border-width: 1.5px;
    border-color: #e0e0e0;
    &__date {
      background: $gradient-background;
    }
  }
}
@keyframes fadeIn {
  0% {
    display: none;
    opacity: 0;
  }
  100% {
    display: block;
    opacity: 1;
  }
}

@keyframes fadeOut {
  0% {
    display: block;
    opacity: 1;
  }
  100% {
    display: none;
    opacity: 0;
  }
}
@media only screen and (max-width: 991px) {
  .course {
    &__banner {
      &__img {
        max-width: none;
      }
    }
  }
}
.vx-row {
  margin: 0;
}
.vx-col {
  padding: 0;
}
</style>
